import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const ServiceCard = ({ title, description, image, link, linkText = "Learn More" }) => {
  // Create shorter descriptive link text for SEO
  const getDescriptiveText = () => {
    // Extract short version of title (first meaningful words)
    const shortTitle = title
      .split(' - ')[0]
      .split('*')[0]
      .replace(/\$\d+/g, '') // Remove prices
      .replace(/®/g, '')
      .trim()
      .split(' ')
      .slice(0, 3) // Take first 3 words
      .join(' ');
    
    if (linkText === "Learn More") {
      return `Learn About ${shortTitle}`;
    }
    if (linkText === "Read More") {
      return `View ${shortTitle} Details`;
    }
    return linkText;
  };

  return (
    <Card className="overflow-hidden hover:shadow-xl transition-shadow duration-300">
      {image && (
        <div className="h-48 overflow-hidden">
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover"
            loading="lazy"
            width={400}
            height={192}
          />
        </div>
      )}
      <CardContent className="p-6">
        <h3 className="text-xl font-bold text-gray-800 mb-3">{title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{description}</p>
        <Link to={link}>
          <Button className="bg-teal-600 hover:bg-teal-700 text-white min-h-[44px]">
            {getDescriptiveText()}
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;